import {
  type Analytics,
  initializeAnalytics,
  isSupported,
} from 'firebase/analytics'

export default defineNuxtPlugin(async () => {
  // Skip analytics in test environment
  if (process.env.VITEST === 'true' || process.env.NODE_ENV === 'test' || process.env.TEST === 'true') {
    return {
      provide: {
        analytics: null,
      },
    }
  }

  const firebaseApp = useFirebaseApp()

  let analytics: Analytics | null = null
  if (await isSupported()) {
    analytics = initializeAnalytics(firebaseApp)
    console.warn('Loaded analytics')
  }
  else {
    console.warn('Analytics not supported')
  }

  return {
    provide: {
      analytics,
    },
  }
})
